import * as React from "react";
import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <>
    <rect
      className="Radio"
      x="6"
      y="6"
      width="12"
      height="12"
      rx="6"
      strokeWidth="4"
    />
    <rect
      className="Radio-focus"
      x="2.5"
      y="2.5"
      width="19"
      height="19"
      rx="9.5"
      stroke="#1AD4FD"
      strokeWidth="3"
    />
  </>,
  "AcUnit"
);
